import { PriceAdjustmentType } from "@/model/enum/PriceAdjustmentType";
import { RuleApplicationStrategy } from "@/model/enum/RuleApplicationStrategy";
import PriceAdjustmentRule from "@/model/PriceAdjustmentRule";
export default class PriceAdjustment {
    id = 0;
    daysOfWeek = [];
    name;
    adjustmentType = PriceAdjustmentType.DISCOUNT;
    calculationBasis;
    referenceId;
    applicationStrategy = RuleApplicationStrategy.STRICTEST_TO_ALL;
    rules = [new PriceAdjustmentRule()];
    init(other) {
        this.id = other.id;
        this.daysOfWeek = other.daysOfWeek || [];
        this.name = other.name;
        this.adjustmentType = other.adjustmentType;
        this.calculationBasis = other.calculationBasis;
        this.referenceId = other.referenceId;
        this.applicationStrategy = other.applicationStrategy;
        this.rules = [];
        for (const rule of other.rules) {
            const newRule = new PriceAdjustmentRule();
            newRule.init(rule);
            this.rules.push(newRule);
        }
    }
}
